<div
  [class]="combinedClasses"
  [class.items-start]="align === 'start'"
  [class.items-center]="align === 'center'"
  [class.justify-between]="showModuleInfo"
>
  <div
    class="flex gap-3"
    [class.items-start]="align === 'start'"
    [class.items-center]="align === 'center'"
    [class.flex-1]="wrapText"
    [class.min-w-0]="wrapText"
  >
    <i
      [class]="icon + ' ' + iconColor + ' text-xl flex-shrink-0'"
      [class.mt-0.5]="align === 'start'"
    ></i>
    <div
      class="flex flex-col justify-center"
      [class.flex-1]="wrapText"
      [class.min-w-0]="wrapText"
    >
      <h3
        class="text-sm font-semibold text-gray-900 dark:text-white leading-tight"
        [class.break-words]="wrapText"
        [class.whitespace-normal]="wrapText"
      >
        {{ title }}
      </h3>
      <p
        *ngIf="subtitle"
        class="text-xs text-gray-500 dark:text-neutral-400 leading-tight mt-0.5"
        [class.break-words]="wrapText"
        [class.whitespace-normal]="wrapText"
      >
        {{ subtitle }}
      </p>
    </div>
  </div>
  @if (showModuleInfo && module) {
  <div class="flex items-center gap-2 text-sm text-gray-700 dark:text-white">
    <i class="bi bi-folder text-gray-500 dark:text-white"></i>
    <span class="font-medium">Módulo: {{ module.name }}</span>
  </div>
  }
</div>
